import moment from 'moment'
import React from 'react'
import DatePicker from "react-datepicker"
import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import Text from 'react-text'
import * as dateLocale from 'date-fns/locale'
import {Consumer} from '../../context'
import "react-datepicker/dist/react-datepicker.css"
import './date-step.styl'

class DateInput extends React.Component {
  render () {
    return (
      <div className="date-input" onClick={this.props.onClick}>
        <FontAwesomeIcon icon={faCalendarAlt} />
        {this.props.value}
      </div>
    )
  }
}

export default function DateStep(props) {

  const setDate = date => props.setState({date})
  const setMessage = event => props.setState({message: event.target.value})

  return (<Consumer>{ context => {
    
    return (
      <div className="date-step">
        <div className="instructions">
          <Text id='schedule_comment_date_instructions' />
        </div>
        <div className="content">
          <div className="date">
            <DatePicker
              customInput={<DateInput />}
              selected={props.date}
              onChange={setDate}
              minDate={new Date()}
              maxDate={moment().add(1,'year').toDate()}
              locale={context.languageId == 'en' ? dateLocale.enUS : dateLocale.es}
            />
          </div>
          <div className="message">
            <div className="label">
              <Text id='message_label' />
            </div>
            <div className="value">
              <textarea
                placeholder={context.translations.schedule_lesson_date_message_placeholder[context.languageId]}
                value={props.message}
                onChange={setMessage}
              />
            </div>
          </div>
        </div>
      </div>
    )
    }}</Consumer>)
  }
